/** "4:12 PM": when a client's record was last fetched, in the reader's zone (the client bar, 21 October, 16:12). */
export function lastUpdated(updatedAt: number): string | null {
  return updatedAt ? new Date(updatedAt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : null;
}
